import { Outlet } from "react-router-dom";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import "./index.css";
import { subscribeToMatchData } from "../../socketClient";
import { useEffect } from "react";

export default function App() {

   useEffect(() => {
     // Subscribe to all matches for each sport
     subscribeToMatchData({
       eventId: 4, // Cricket
       competitionId: null,
       matchId: null,
       marketId: null,
       sport: "cricket",
     });
     subscribeToMatchData({
       eventId: 1, // Soccer (fixed order to match your backend convention)
       competitionId: null,
       matchId: null,
       marketId: null,
       sport: "soccer",
     });
     subscribeToMatchData({
       eventId: 2, // Tennis
       competitionId: null,
       matchId: null,
       marketId: null,
       sport: "tennis",
     });
     
   }, []);
 

  return (
    <div className="min-h-[calc(100vh-65px)] bg-[#0B1622] relative flex flex-col">
      <div className="fixed w-full z-10 top-0 ">
        <Navbar />
      </div>
      <div className="fixed bottom-0 left-0 right-0 w-full md:top-[65px] z-10 md:z-0">
        <Sidebar />
      </div>
      <div className="flex-1 pb-24 md:pb-6 md:pl-[90px]">
        <div className="relative pt-[90px] clk">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
